<template>
  <v-card>
    <v-card-title primary-title>
      <span class="title">Lista de comentários</span>
      <v-btn absolute dark fab top right color="orange" @click="showDialog">
        <v-icon>add</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-if="feedbacks"
        :headers="headers"
        :items="feedbacks"
        :mobile-breakpoint="960"
        disable-pagination
        hide-default-header
        hide-default-footer
        disable-sort
        class="feedbacksTable"
      >
        <!-- <template v-slot:item.type="{ item }">
          {{item)}}
        </template> -->
        <template v-slot:item.type="{ item }">
          {{ changeTypes(item.type) }}
        </template>

        <template v-slot:item.rate="{ item }">
          <v-rating
            v-model="item.rate"
            background-color="orange lighten-3"
            color="orange"
            small
            readonly
          ></v-rating>
        </template>

        <template v-slot:item.created="{ item }">
          {{ item.created | formatDate }}
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="show" persistent max-width="1000px">
      <v-card>
        <Feedback @close="closeDialog" :trackId="trackId" inDialog />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="show = false" class="red white--text">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import appApi from "@/plugins/api";
import Feedback from "@/views/feedback/Feedback.vue";

export default {
  components: {
    Feedback: Feedback
  },

  props: {
    trackId: String,
    showThis: Boolean
  },

  watch: {
    showThis() {
      this.show = true;
    }
  },

  data() {
    return {
      headers: [
        { text: "Nome", value: "user.name" },
        { text: "Email", value: "user.email" },
        { text: "Telefone", value: "user.phone" },
        { text: "Comentário", sortable: false, value: "comment" },
        { text: "Tipo de Comentário", value: "type" },
        { text: "Nota", align: "center", value: "rate" },
        { text: "Data", align: "center", value: "created" }
      ],
      feedbacks: [],
      totalPage: 0,
      show: false
    };
  },

  created() {
    if (this.$route.params.id) {
      appApi
        .getFeedback({ track_id: this.$route.params.id })
        .then(result => {
          this.feedbacks = result.data.data;
        })
        .catch(error => {
          console.log("erro: ", error);
        });
    }
  },
  methods: {
    changeTypes(val) {
      switch (val) {
        case (val = 1):
          return "Sugestão";
          break;
        case (val = 2):
          return "Elogio";
          break;
        case (val = 3):
          return "Reclamação";
          break;
        default:
          return val;
      }
    },

    showDialog() {
      this.$emit("holdPageBottom");
      this.show = true;
    },
    closeDialog() {
      this.show = false;

      appApi
        .getFeedback({ track_id: this.$route.params.id })
        .then(result => {
          this.feedbacks = result.data.data;
        })
        .catch(error => {
          console.log("erro: ", error);
        });

      this.$emit("holdPageBottom");
    }
  }
};
</script>

<style scoped lang="scss">
.feedbacksTable::v-deep {
  @media screen and (max-width: 960px) {
    tr {
      display: block;
      margin-bottom: 10px;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

      .v-data-table__mobile-row:nth-of-type(odd) {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
    }
  }
}
</style>
